import React from 'react'

const Drizzle = () => {
  return (
    <svg
      width='285'
      height='233'
      viewBox='0 0 285 233'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='54.7664'
        y='196.774'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 54.7664 196.774)'
        fill='url(#paint0_linear_1_88)'
      />
      <rect
        x='94.2784'
        y='196.774'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 94.2784 196.774)'
        fill='url(#paint1_linear_1_88)'
      />
      <rect
        x='133.79'
        y='196.774'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 133.79 196.774)'
        fill='url(#paint2_linear_1_88)'
      />
      <rect
        x='173.302'
        y='196.774'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 173.302 196.774)'
        fill='url(#paint3_linear_1_88)'
      />
      <rect
        x='76.4437'
        y='148'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 76.4437 148)'
        fill='url(#paint4_linear_1_88)'
      />
      <rect
        x='115.956'
        y='148'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 115.956 148)'
        fill='url(#paint5_linear_1_88)'
      />
      <rect
        x='155.468'
        y='148'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 155.468 148)'
        fill='url(#paint6_linear_1_88)'
      />
      <rect
        x='194.98'
        y='148'
        width='12.1935'
        height='33.8707'
        rx='6.09673'
        transform='rotate(15 194.98 148)'
        fill='url(#paint7_linear_1_88)'
      />
      <g filter='url(#filter0_bd_1_88)'>
        <mask
          id='path-9-outside-1_1_88'
          maskUnits='userSpaceOnUse'
          x='15'
          y='11'
          width='255'
          height='155'
          fill='black'
        >
          <rect fill='white' x='15' y='11' width='255' height='155' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M197.882 82.0141C197.882 84.4233 197.758 86.8036 197.517 89.149C204.953 82.6871 214.664 78.7752 225.288 78.7752C248.68 78.7752 267.643 97.7383 267.643 121.13C267.643 144.523 248.68 163.486 225.288 163.486H60.6379C60.6256 163.486 60.6133 163.486 60.601 163.486C60.5887 163.486 60.5764 163.486 60.5641 163.486H60.3518V163.485C36.3863 163.351 17 143.882 17 119.885C17 95.9758 36.2441 76.5617 60.0878 76.2867C62.999 40.8508 92.6809 13 128.868 13C166.983 13 197.882 43.8987 197.882 82.0141Z'
          />
        </mask>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M197.882 82.0141C197.882 84.4233 197.758 86.8036 197.517 89.149C204.953 82.6871 214.664 78.7752 225.288 78.7752C248.68 78.7752 267.643 97.7383 267.643 121.13C267.643 144.523 248.68 163.486 225.288 163.486H60.6379C60.6256 163.486 60.6133 163.486 60.601 163.486C60.5887 163.486 60.5764 163.486 60.5641 163.486H60.3518V163.485C36.3863 163.351 17 143.882 17 119.885C17 95.9758 36.2441 76.5617 60.0878 76.2867C62.999 40.8508 92.6809 13 128.868 13C166.983 13 197.882 43.8987 197.882 82.0141Z'
          fill='url(#paint8_linear_1_88)'
          shapeRendering='crispEdges'
        />
        <path
          d='M197.517 89.149L195.528 88.9447L195.011 93.9771L198.829 90.6586L197.517 89.149ZM60.3518 163.486H58.3518V165.486H60.3518V163.486ZM60.3518 163.485H62.3518V161.496L60.363 161.485L60.3518 163.485ZM60.0878 76.2867L60.1109 78.2866L61.932 78.2655L62.0811 76.4504L60.0878 76.2867ZM199.507 89.3534C199.755 86.9401 199.882 84.4916 199.882 82.0141H195.882C195.882 84.3549 195.762 86.667 195.528 88.9447L199.507 89.3534ZM225.288 76.7752C214.163 76.7752 203.991 80.8733 196.206 87.6395L198.829 90.6586C205.915 84.5008 215.164 80.7752 225.288 80.7752V76.7752ZM269.643 121.13C269.643 96.6337 249.785 76.7752 225.288 76.7752V80.7752C247.576 80.7752 265.643 98.8429 265.643 121.13H269.643ZM225.288 165.486C249.785 165.486 269.643 145.627 269.643 121.13H265.643C265.643 143.418 247.576 161.486 225.288 161.486V165.486ZM225.288 161.486H60.6379V165.486H225.288V161.486ZM60.601 165.486C60.6079 165.486 60.6146 165.486 60.6207 165.486C60.6269 165.486 60.6324 165.486 60.6379 165.486V161.486C60.631 161.486 60.6242 161.486 60.6182 161.486C60.6119 161.486 60.6064 161.486 60.601 161.486V165.486ZM60.5641 165.486C60.5695 165.486 60.5751 165.486 60.5813 165.486C60.5873 165.486 60.5941 165.486 60.601 165.486V161.486C60.5956 161.486 60.59 161.486 60.5838 161.486C60.5778 161.486 60.571 161.486 60.5641 161.486V165.486ZM60.5641 161.486H60.3518V165.486H60.5641V161.486ZM62.3518 163.486V163.485H58.3518V163.486H62.3518ZM15 119.885C15 144.983 35.2756 165.345 60.3407 165.485L60.363 161.485C37.4971 161.357 19 142.781 19 119.885H15ZM60.0647 74.2868C35.1268 74.5744 15 94.879 15 119.885H19C19 97.0727 37.3614 78.5489 60.1109 78.2866L60.0647 74.2868ZM128.868 11C91.6312 11 61.0902 39.6581 58.0945 76.1229L62.0811 76.4504C64.9077 42.0436 93.7306 15 128.868 15V11ZM199.882 82.0141C199.882 42.7941 168.088 11 128.868 11V15C165.879 15 195.882 45.0033 195.882 82.0141H199.882Z'
          fill='url(#paint9_linear_1_88)'
          mask='url(#path-9-outside-1_1_88)'
        />
      </g>
      <defs>
        <filter
          id='filter0_bd_1_88'
          x='0'
          y='0'
          width='284.643'
          height='184.486'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='5' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_1_88'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='7.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_backgroundBlur_1_88'
            result='effect2_dropShadow_1_88'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_1_88'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_1_88'
          x1='56.1212'
          y1='226.58'
          x2='66.9599'
          y2='200.838'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1_88'
          x1='95.6332'
          y1='226.58'
          x2='106.472'
          y2='200.838'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1_88'
          x1='135.145'
          y1='226.58'
          x2='145.984'
          y2='200.838'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1_88'
          x1='174.657'
          y1='226.58'
          x2='185.496'
          y2='200.838'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_1_88'
          x1='77.7985'
          y1='177.806'
          x2='88.6371'
          y2='152.064'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_1_88'
          x1='117.31'
          y1='177.806'
          x2='128.149'
          y2='152.064'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_1_88'
          x1='156.822'
          y1='177.806'
          x2='167.661'
          y2='152.064'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_1_88'
          x1='196.334'
          y1='177.806'
          x2='207.173'
          y2='152.064'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#3981EE' />
          <stop offset='1' stopColor='#92BDFF' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_1_88'
          x1='96.5248'
          y1='28.5'
          x2='176.025'
          y2='158'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#508ABF' />
          <stop offset='1' stopColor='#2073A2' stopOpacity='0.53' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_1_88'
          x1='177.525'
          y1='213.5'
          x2='99.5247'
          y2='-6.49999'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4195C6' />
          <stop offset='1' stopColor='#5E8398' stopOpacity='0.56' />
          <stop offset='1' stopColor='#AFE2FF' stopOpacity='0.5' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Drizzle
